export const arrSortMinMax = (_arr, _key) =>
  _arr.sort((a, b) => (a[_key] > b[_key] ? 1 : -1))

export const arrSortMaxMin = (_arr, _key) =>
  _arr.sort((a, b) => (a[_key] < b[_key] ? 1 : -1))
